import { Box } from '@fundamentals'
import { Chip } from '@common/material'
import React from 'react'
import { PageUrls } from '@core/page-urls'
import { useRegisterContext } from '@modules/registers/details/RegisterContext'
import {
  RegisterItemTaskProperty,
  TaskStatusCounts,
} from '@core/entities/register/RegisterItem'
import { RegisterItemContentVariant } from '@modules/registers/items/types'
import { Task } from '@core/entities/task/Task'
import { TaskStatusChip } from '@modules/tasks/components/TaskStatusChip'
import { statuses } from '@core/theme/statuses'

type ActiveTaskStatusChipsProps = {
  registerItemId?: number
  totalTasks?: number
  statusCountArray: Array<TaskStatusCounts>
  onTaskClick?: () => void
}

export const ActiveTaskStatusChips: React.FC<ActiveTaskStatusChipsProps> = ({
  registerItemId,
  totalTasks = 0,
  statusCountArray,
  onTaskClick,
}) => {
  const { scope, registerId } = useRegisterContext()

  const handleChipClick = () => {
    if (onTaskClick) {
      onTaskClick()
    } else if (registerItemId) {
      if (!totalTasks || !scope?.organisationId) return
      window.open(
        PageUrls.registerItemDetails({
          organisationId: scope.organisationId,
          registerId,
          registerItemId,
          tab: 'Tasks',
        }),
      )
    }
  }

  return (
    <Box display='flex' flexWrap='wrap' gap={1}>
      {totalTasks >= 0 && (
        <Chip
          variant='outlined'
          label={totalTasks}
          size='small'
          onClick={handleChipClick}
          clickable={!(!totalTasks || !scope?.organisationId) || !!onTaskClick}
        />
      )}
      {statusCountArray.map(({ status, count }) =>
        status === 'OVERDUE' ? (
          <Chip
            key={status}
            color={statuses.overdue.color}
            label={`${statuses.overdue.label} (${count})`}
            size='small'
            onClick={handleChipClick}
          />
        ) : (
          <TaskStatusChip
            key={status}
            status={status}
            label={`${Task.statusString(status)} (${count})`}
            size='small'
            onClick={handleChipClick}
          />
        ),
      )}
    </Box>
  )
}

type RegisterItemPropertyTaskValueProps = {
  registerItemPropertyData: RegisterItemTaskProperty<string>
  variant?: RegisterItemContentVariant
  statusCountArray: Array<TaskStatusCounts>
  onTaskClick?: () => void
}

export const RegisterItemPropertyTaskValue: React.FC<
  RegisterItemPropertyTaskValueProps
> = ({ registerItemPropertyData, statusCountArray, onTaskClick }) => {
  return (
    <ActiveTaskStatusChips
      totalTasks={registerItemPropertyData?.totalTasks}
      statusCountArray={statusCountArray}
      onTaskClick={onTaskClick}
    />
  )
}
